import { defineComponent, computed, watchEffect, useSlots, openBlock, createElementBlock, normalizeStyle, unref, Fragment, renderList, createVNode, withCtx, renderSlot, createElementVNode } from "vue";
import { u as useGridTemplateArea } from "./hooks/useGridTemplateArea.js";
import { u as useLayoutProps, a as useLayout } from "./hooks/useLayout.js";
import { _ as _sfc_main$1 } from "./components/VaLayoutArea.vue_vue_type_script_setup_true_lang.js";
import { u as useDocument } from "../../composables/useDocument.js";
const _hoisted_1 = { class: "va-layout__area va-layout__area--content" };
const areaNames = [
  "top",
  "left",
  "right",
  "bottom"
];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaLayout"
  },
  __name: "VaLayout",
  props: {
    ...useLayoutProps,
    allowBodyScrollOnOverlay: { type: Boolean, default: false }
  },
  emits: [
    "top-overlay-click",
    "left-overlay-click",
    "right-overlay-click",
    "bottom-overlay-click"
  ],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const { paddings } = useLayout(props);
    const doDisableScroll = computed(() => {
      return !props.allowBodyScrollOnOverlay && areaNames.some((area) => {
        var _a;
        return (_a = props[area]) == null ? void 0 : _a.overlay;
      });
    });
    const document = useDocument();
    watchEffect(() => {
      var _a;
      const overflowParent = (_a = document.value) == null ? void 0 : _a.body;
      if (!overflowParent) {
        return;
      }
      if (doDisableScroll.value) {
        overflowParent.style.overflow = "hidden";
      } else {
        overflowParent.style.overflow = "";
      }
    });
    const templateArea = useGridTemplateArea(props);
    const slots = useSlots();
    const verticalTemplate = computed(() => {
      return [
        slots.top ? "min-content" : "0fr",
        "1fr",
        slots.bottom ? "min-content" : "0fr"
      ].filter(Boolean).join(" ");
    });
    const horizontalTemplate = computed(() => {
      return [
        slots.left ? "min-content" : "0fr",
        "1fr",
        slots.right ? "min-content" : "0fr"
      ].filter(Boolean).join(" ");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "va-layout",
        style: normalizeStyle(`--va-horizontal-template: ${String(horizontalTemplate.value)};--va-vertical-template: ${String(verticalTemplate.value)};--va-template-area: ${String(unref(templateArea))};--va-paddings-top-px: ${String(unref(paddings).top + "px")};--va-paddings-bottom-px: ${String(unref(paddings).bottom + "px")};--va-paddings-left-px: ${String(unref(paddings).left + "px")};--va-paddings-right-px: ${String(unref(paddings).right + "px")}`)
      }, [
        (openBlock(), createElementBlock(Fragment, null, renderList(areaNames, (area) => {
          return createVNode(_sfc_main$1, {
            key: area,
            area,
            config: _ctx.$props[area] || {},
            onOverlayClick: ($event) => _ctx.$emit(`${area}-overlay-click`)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, area)
            ]),
            _: 2
          }, 1032, ["area", "config", "onOverlayClick"]);
        }), 64)),
        createElementVNode("div", _hoisted_1, [
          renderSlot(_ctx.$slots, "default", {}, () => [
            renderSlot(_ctx.$slots, "content")
          ])
        ])
      ], 4);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaLayout.css';
//# sourceMappingURL=VaLayout.vue_vue_type_script_setup_true_lang.js.map
